import * as React from 'react';
import injectSheet, { JSSClassesProps } from 'react-jss';
import { logError as sentryLogError } from 'sletat-sentry';

import { StatusLogo as _StatusLogo, StatusLogoProps } from 'sletat-ui-components/lib/StatusLogo';

import { ComponentJSSClasses, statusLogoStyle } from './styles';

const FailedStatusLogo = injectSheet<StatusLogoProps>(statusLogoStyle)(_StatusLogo);

export interface ErrorInterceptorProps {}
export interface ErrorInterceptorState {
    isError: boolean;
}

interface StyledErrorInterceptorProps extends JSSClassesProps<ComponentJSSClasses>, ErrorInterceptorProps {}


export class ErrorInterceptor extends React.Component<StyledErrorInterceptorProps, ErrorInterceptorState> {

    constructor(props: StyledErrorInterceptorProps) {
        super(props);
        this.state = {
            isError: false
        };
    }


    componentDidCatch(err: Error) {
        this.setState({
            isError: true
        });
        sentryLogError(err);
    }


    render() {
        if (!this.state.isError) {
            return this.props.children;
        }

        const { classes } = this.props;

        return (
            <div className={classes.container}>
                <FailedStatusLogo />
                <h1 className={classes.title}>Что-то пошло не так...</h1>
                <div className={classes.text}>Сервис недоступен из-за технических трудностей. Но мы уже работаем над проблемой, и скоро всё будет в порядке. Пожалуйста, зайдите через несколько минут.</div>
            </div>
        );

    }

}
